import { render, staticRenderFns } from "./BeLanguageSelect.vue?vue&type=template&id=31464370&scoped=true"
import script from "./BeLanguageSelect.vue?vue&type=script&lang=js"
export * from "./BeLanguageSelect.vue?vue&type=script&lang=js"
import style0 from "./BeLanguageSelect.vue?vue&type=style&index=0&id=31464370&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31464370",
  null
  
)

export default component.exports